import { useState } from "react";

interface ConfirmButtonProps {
  onConfirm: () => void | Promise<void>;
  children: React.ReactNode;
  /** Message shown when in confirm state. */
  confirmLabel?: string;
  className?: string;
  confirmClassName?: string;
  title?: string;
}

/**
 * A button that requires two clicks to act: first click arms it, second
 * click (within the timeout) confirms. Resets on blur/timeout.
 */
export function ConfirmButton({
  onConfirm,
  children,
  confirmLabel,
  className = "",
  confirmClassName = "",
  title,
}: ConfirmButtonProps) {
  const [armed, setArmed] = useState(false);

  return (
    <button
      type="button"
      title={title}
      onBlur={() => setArmed(false)}
      className={armed ? confirmClassName : className}
      onClick={() => {
        if (armed) {
          setArmed(false);
          void onConfirm();
        } else {
          setArmed(true);
          window.setTimeout(() => setArmed(false), 2500);
        }
      }}
    >
      {armed ? (confirmLabel ?? "Confirm?") : children}
    </button>
  );
}